var _effectorFileName = "/src/shared/components/contact-form/model.ts";
import { createEvent, createStore, sample } from 'effector';
import { QuizContactFormData } from '@/features/quiz/components/quiz-contact-form';
import { postContactFormMutation } from '@/shared/api/send-message/api';
import { ContactFormData } from './types';
export const contactFormDataSent = createEvent<ContactFormData>({
  loc: {
    file: _effectorFileName,
    line: 9,
    column: 35
  },
  name: "contactFormDataSent",
  sid: "-i162as"
});
export const $isContactFormSentSuccessfully = createStore<boolean>(false, {
  loc: {
    file: _effectorFileName,
    line: 10,
    column: 46
  },
  name: "$isContactFormSentSuccessfully",
  sid: "-ln1xfb"
});
sample({
  and: [{
    clock: contactFormDataSent,
    fn: data => data,
    target: postContactFormMutation.start
  }],
  or: {
    loc: {
      file: _effectorFileName,
      line: 12,
      column: 0
    },
    sid: "-ymv9m"
  }
});
sample({
  and: [{
    clock: postContactFormMutation.finished.success,
    fn: () => true,
    target: $isContactFormSentSuccessfully
  }],
  or: {
    loc: {
      file: _effectorFileName,
      line: 18,
      column: 0
    },
    sid: "-vc3pg"
  }
});
export const quizFormDataSent = createEvent<QuizContactFormData>({
  loc: {
    file: _effectorFileName,
    line: 24,
    column: 32
  },
  name: "quizFormDataSent",
  sid: "-o1bdzl"
});
sample({
  and: [{
    clock: quizFormDataSent,
    fn: data => data,
    target: postContactFormMutation.start
  }],
  or: {
    loc: {
      file: _effectorFileName,
      line: 26,
      column: 0
    },
    sid: "-fe2hz"
  }
});